import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { ModalityOrbit } from './ModalityOrbit';
import { orbitNodes } from '../../data/modalities';
const fade = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: index * 0.08,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};
export function Hero() {
  return <section className="relative w-full max-w-[100vw] overflow-hidden bg-white" data-id="element-92" data-mp="3783j6obg4b07">
      <img src="https://cdn.magicpatterns.com/uploads/jcxmq9exrVrKEqcEaZF8dP/jag-hero-balanced-room-v3.png" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover object-[72%_center] opacity-[0.34] sm:opacity-[0.44] lg:opacity-[0.78]" data-id="element-93" data-mp="3c390f9twl1hy" />
      <div className="pointer-events-none absolute inset-0 bg-white/68 sm:bg-white/60 lg:bg-white/24" data-id="element-94" data-mp="1msibu7iu4za5" />
      <div className="pointer-events-none absolute inset-y-0 left-0 w-full bg-white/58 sm:bg-white/52 lg:w-[54%] lg:bg-white/82" data-id="element-95" data-mp="1qtk94it6z19h" />
      <div className="relative mx-auto grid w-full max-w-[100vw] items-center gap-10 px-5 py-14 sm:max-w-7xl sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:py-20" data-id="element-96" data-mp="1y7lryx5onxcy">
        <div className="w-full min-w-0 max-w-xs sm:max-w-xl" data-id="element-97" data-mp="1t6fy2w0ae41u">
          <motion.p variants={fade} initial="hidden" animate="show" custom={0} className="w-full min-w-0 max-w-xs whitespace-normal break-words text-[11px] font-semibold uppercase tracking-[0.08em] text-teal sm:max-w-xl sm:text-[12px] sm:tracking-[0.16em] lg:text-[13px] xl:text-[14px]" data-id="element-98" data-mp="1ob0l06a3sc6h">
            <span className="block sm:inline" data-id="element-99" data-mp="270fkvxe1yv9a">Therapeutic Modalities,</span>{' '}
            <span className="block sm:inline" data-id="element-100" data-mp="272jlo6gnne5c">Matched to Your Practice</span>
          </motion.p>
          <motion.h1 variants={fade} initial="hidden" animate="show" custom={1} className="mt-4 w-full min-w-0 max-w-xs whitespace-normal break-words font-display text-[2rem] font-extrabold leading-[1.08] tracking-tight text-navy sm:max-w-xl sm:text-5xl sm:leading-[1.05] lg:text-[3.75rem] xl:text-[4rem]" data-id="element-101" data-mp="10hqvesjl1qnz">
            <span className="block sm:inline" data-id="element-102" data-mp="39sjizz5byqwk">More Than Equipment.</span>{' '}
            <span className="block sm:inline" data-id="element-103" data-mp="3eqkyka3js83a">The Right Technology,</span>{' '}
            <span className="block sm:inline" data-id="element-104" data-mp="302q52rhptzp5">Implemented the</span>{' '}
            <span className="block sm:inline" data-id="element-105" data-mp="34tos09x7lw1d">Right Way.</span>
          </motion.h1>
          <motion.p variants={fade} initial="hidden" animate="show" custom={2} className="mt-6 w-full min-w-0 max-w-xs whitespace-normal break-words text-[17px] leading-relaxed text-charcoal/75 sm:max-w-xl lg:text-[18px] xl:text-[19px] xl:leading-[1.65]" data-id="element-106" data-mp="34vjcjn4kjm4x">
            JAG Medical Solutions helps doctors cut through modality hype,
            compare proven technologies, and choose equipment that fits their
            patients, team, and growth goals.
          </motion.p>
          <motion.div variants={fade} initial="hidden" animate="show" custom={3} className="mt-8 flex w-full max-w-xs flex-col gap-3 sm:w-auto sm:max-w-none sm:flex-row" data-id="element-107" data-mp="1ygvb8iahvbxz">
            <a href="tel:+19414416131" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 sm:w-auto" data-id="element-108" data-mp="27il3fqc7aewt">
              <PhoneIcon className="h-[18px] w-[18px]" data-id="element-109" data-mp="2q816akbcyjge" />
              Call (941) 441-6131
            </a>
            <a href="#products" className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-3.5 text-[15px] font-semibold text-navy transition-colors hover:border-teal hover:text-teal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 sm:w-auto" data-id="element-110" data-mp="3551ysq1diifx">
              Explore Product Categories
              <ArrowRightIcon className="h-[18px] w-[18px]" data-id="element-111" data-mp="17ao1dggm8ok6" />
            </a>
          </motion.div>
          <motion.p variants={fade} initial="hidden" animate="show" custom={4} className="mt-4 w-full min-w-0 max-w-xs whitespace-normal break-words text-sm font-medium text-charcoal/60 sm:max-w-xl" data-id="element-112" data-mp="1c993jlffhib9">
            Talk with JAG Medical Solutions about the right fit for your
            practice.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="hidden justify-center lg:flex" data-id="element-113" data-mp="tekcm2oih8f3">
          <ModalityOrbit data-id="element-114" data-mp="3kfjjaukx1szg" />
        </motion.div>

        <div className="grid w-full min-w-0 max-w-xs grid-cols-1 gap-3 sm:max-w-none sm:grid-cols-2 lg:hidden" data-id="element-115" data-mp="3fo1m8hm0kcjr">
          {orbitNodes.map(node => <div key={node.id} className="min-w-0 rounded-2xl border border-slate-100 bg-white/95 p-4 shadow-sm" data-id="element-116" data-mp="3aoye2oaqlq7k">
              <p className="break-words font-display text-sm font-bold leading-tight text-navy" data-id="element-117" data-mp="31o0hgr2mokz0">
                {node.name}
              </p>
              <p className="mt-1.5 break-words text-xs leading-snug text-charcoal/55" data-id="element-118" data-mp="2wppbirfgeum2">
                {node.detail}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}